import { EventData } from '../../../models/event-data';
import { StepData } from '../../../models/step-data';
import { AnyActionData } from '../../../models/Types/any-action-data';
import { AnyConditionData } from '../../../models/Types/any-condition-data';
import { AnyTriggerData } from '../../../models/Types/any-trigger-data';

/**
 * évènement émis lorsque le formulaire a été modifié.
 */
export class FormUpdatedEvent {
    /**
     * Constructeur.
     * @param type : Type d'élement modifié (noeud ou connexion).
     * @param id : Id de l'élément
     * @param data : Données du formulaire.
     */
    constructor(
        public type: 'node' | 'connection',
        public nodeType: 'step' | 'action' | 'trigger',
        public id: string,
        public data: EventData | StepData | AnyTriggerData | AnyActionData | AnyConditionData
    ) {}
}
